import { render, staticRenderFns } from "./register-inner-bv.vue?vue&type=template&id=0c3ca12a&"
import script from "./register-inner-bv.vue?vue&type=script&lang=js&"
export * from "./register-inner-bv.vue?vue&type=script&lang=js&"
import style0 from "./register-inner-bv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports